import React, { useState } from "react";
import { Check, Search } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import { inputCls } from "@/components/InquiryForm";

const VEHICLE_FIELDS = [
  ["marke", "Marke *", true], ["modell", "Modell *", true], ["budget", "Budget (z. B. € 80.000)"],
  ["motorisierung", "Motorisierung"], ["farbe", "Farbe"], ["baujahr", "Baujahr ab"],
  ["kilometer", "Kilometer bis"], ["ausstattung", "Wunschausstattung"],
];

export default function Findet() {
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [d, setD] = useState({ wuensche: "", name: "", email: "", phone: "", ...Object.fromEntries(VEHICLE_FIELDS.map(([k]) => [k, ""])) });
  const set = (k) => (e) => setD({ ...d, [k]: e.target.value });
  usePageMeta("Wunschfahrzeug", "Ihr Wunschfahrzeug ist nicht im Bestand? AD MOTORS hält für Sie die Augen offen.");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { wuensche, name, email, phone, ...vehicle } = d;
      await api.post("/leads", {
        type: "findet", name, email, phone, message: `Wunschfahrzeug: ${d.marke} ${d.modell}`,
        data: { ...vehicle, besondere_wuensche: wuensche },
      });
      setDone(true);
    } catch {
      toast.error("Anfrage konnte nicht gesendet werden.");
    }
    setLoading(false);
  };

  if (done)
    return (
      <div data-testid="findet-success" className="pt-36 pb-24 max-w-2xl mx-auto px-5 sm:px-8 text-center">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand text-brand-ink mb-8"><Check size={28} /></span>
        <h1 className="font-display font-bold text-4xl sm:text-5xl text-ink mb-5">Vielen Dank.</h1>
        <p className="text-dim leading-relaxed max-w-md mx-auto">
          Ihr Suchauftrag für <strong className="text-ink">{d.marke} {d.modell}</strong> ist bei uns eingegangen.
          Wir melden uns, sobald wir ein passendes Fahrzeug für Sie haben.
        </p>
      </div>
    );

  return (
    <div data-testid="findet-page" className="pt-28 md:pt-36 pb-24">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <p className="eyebrow">Wunschfahrzeug</p>
        <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1] text-ink mt-5 mb-6 tracking-tight">
          Ihr Wunschauto.<br /><span className="chrome-text">Wir halten Ausschau.</span>
        </h1>
        <p className="text-dim max-w-xl leading-relaxed mb-14">
          Ihr Wunschfahrzeug ist nicht in unserem Bestand? Beschreiben Sie es uns – wir melden uns, sobald wir ein
          passendes Angebot für Sie haben.
        </p>
        <form onSubmit={submit} className="space-y-10">
          <div>
            <p className="font-display font-bold text-ink mb-5">Das Fahrzeug</p>
            <div className="grid sm:grid-cols-2 gap-4">
              {VEHICLE_FIELDS.map(([k, ph, req]) => (
                <input key={k} data-testid={`findet-${k}-input`} required={!!req} placeholder={ph} value={d[k]} onChange={set(k)} className={inputCls} />
              ))}
            </div>
            <textarea data-testid="findet-wuensche-input" rows={3} placeholder="Besondere Wünsche…" value={d.wuensche} onChange={set("wuensche")}
              className={`${inputCls} mt-4 resize-none`} />
          </div>
          <div>
            <p className="font-display font-bold text-ink mb-5">Ihre Kontaktdaten</p>
            <div className="grid sm:grid-cols-3 gap-4">
              <input data-testid="findet-name-input" required placeholder="Name *" value={d.name} onChange={set("name")} className={inputCls} />
              <input data-testid="findet-email-input" required type="email" placeholder="E-Mail *" value={d.email} onChange={set("email")} className={inputCls} />
              <input data-testid="findet-phone-input" placeholder="Telefon" value={d.phone} onChange={set("phone")} className={inputCls} />
            </div>
          </div>
          <button data-testid="findet-submit-btn" type="submit" disabled={loading}
            className="btn-pill inline-flex items-center gap-2 bg-action text-action-ink hover:bg-action-hover font-semibold px-10 py-4 text-sm disabled:opacity-50">
            <Search size={16} /> {loading ? "Wird gesendet…" : "Suchauftrag senden"}
          </button>
        </form>
      </div>
    </div>
  );
}
